import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth.js'
import ErrorView from '@/views/ErrorView.vue'
import axios from 'axios'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/login',
      name: 'login',
      meta: {
        layout: 'AuthLayout',
      },
      component: () => import('@/views/Auth/LoginView.vue'),
    },
    // Rutas nuevas
    {
      path: '/',
      name: 'dashboard',
      component: () => import('@/views/Dashboard/IndexDashboard.vue'),
      meta: {
        iconClass: 'fa fa-dashboard',
        menuName: 'Dashboard',
        showSidebar: true,
        permission: 'dashboard',
        layout: 'MainLayout',
        requiresAuth: true,
      },
    },

    // Tercero

    {
      path: '/tercero',
      name: 'tercero',
      component: () => import('@/views/Tercero/TeceroMainVue.vue'),
      meta: {
        iconClass: 'fa-solid fa-users',
        title: 'Tercero',
        menuName: 'Tercero',
        showSidebar: true,
        layout: 'MainLayout',
        permission: 'dashboard',
      },
      children: [
        {
          path: 'nuevo',
          name: 'tercero.nuevo',
          component: () => import('@/views/Tercero/pages/FormularioTercero.vue'),
          meta: {
            iconClass: 'fa-solid fa-users',
            title: 'Crear tercero',
            showSidebar: false,
            permission: 'tercero.create',
            mainView: 'tercero',
            reload: true,
          },
        },
        {
          path: 'edit/id/:id',
          name: 'tercero.update',
          component: () => import('@/views/Tercero/pages/FormularioTercero.vue'),
          meta: {
            title: 'Edición tercero',
            showSidebar: false,
            permission: 'tercero.update',
            mainView: 'tercero',
            reload: true,
          },
        },
      ],
    },

    // Gestion estatretica
    {
      path: '/gestionestrategica',
      name: 'gestionestrategica',
      component: () => import('@/views/Dashboard/IndexDashboard.vue'),
      meta: {
        iconClass: 'fa-solid fa-list-check',
        menuName: 'Gestión estratégica',
        showSidebar: true,
        permission: 'dashboard',
        layout: 'MainLayout',
      },
    },

    // Gestion presupuestal
    {
      path: '/gestionpresupuestal',
      name: 'gestionpresupuestal',
      meta: {
        iconClass: 'fa-solid fa-hand-holding-dollar',
        menuName: 'Gestión presupuestal',
        showSidebar: true,
        permission: 'gestionpresupuestal',
        layout: 'MainLayout',
      },
    },
    {
      path: '/gestionpresupuestal/presupuestogasto',
      name: 'gestionpresupuestal.presupuestogasto',
      component: () =>
        import('@/views/GestionPresupuestal/PresupuestoGasto/mainViewPresupuestoGasto.vue'),
      meta: {
        menuName: 'Presupuesto gasto',
        showSidebar: true,
        permission: 'gestionpresupuestal.presupuestogasto',
        layout: 'MainLayout',
        parent: 'gestionpresupuestal',
      },
    },
    {
      path: '/gestionpresupuestal/presupuestogasto/parametrizacion',
      name: 'gestionpresupuestal.presupuestogasto.parametrizacion',
      component: () =>
        import(
          '@/views/GestionPresupuestal/PresupuestoGasto/Parametrizacion/mainViewParametrizacion.vue'
        ),
      meta: {
        menuName: 'Parametrización',
        showSidebar: true,
        permission: 'gestionpresupuestal.presupuestogasto.parametrizacion',
        title: 'Parametrización presupuesto del gasto',
        layout: 'MainLayout',
        parent: 'gestionpresupuestal.presupuestogasto',
      },
    },

    {
      path: '/gestionpresupuestal/presupuestogasto/parametrizacion/catalogoccpet',
      name: 'gestionpresupuestal.presupuestogasto.parametrizacion.catalogoccpet',
      component: () =>
        import(
          '@/views/GestionPresupuestal/PresupuestoGasto/Parametrizacion/CatalogoCcpet/CatalogoCcpetMainView.vue'
        ),
      meta: {
        menuName: 'Catálogo CCPET',
        showSidebar: true,
        permission: 'gestionpresupuestal.presupuestogasto.parametrizacion.catalogoccpet',
        title:
          'Catálogo Presupuestal para las Empresas Industriales y Comerciales del Estado (Gasto)',
        layout: 'MainLayout',
        parent: 'gestionpresupuestal.presupuestogasto.parametrizacion',
      },
    },
    {
      path: '/gestionpresupuestal/presupuestogasto/parametrizacion/rubrogasto',
      name: 'gestionpresupuestal.presupuestogasto.parametrizacion.rubrogasto',
      component: () =>
        import(
          '@/views/GestionPresupuestal/PresupuestoGasto/Parametrizacion/RubroGasto/MainViewRubroGasto.vue'
        ),
      meta: {
        menuName: 'Rubro gasto',
        showSidebar: true,
        permission: 'gestionpresupuestal.presupuestogasto.parametrizacion.rubrogasto',
        title: 'Rubro presupuestal del gasto',
        layout: 'MainLayout',
        parent: 'gestionpresupuestal.presupuestogasto.parametrizacion',
      },
      children: [
        {
          path: '/gestionpresupuestal/presupuestogasto/parametrizacion/rubrogasto/nuevo',
          name: 'gestionpresupuestal.presupuestogasto.parametrizacion.rubrogasto.create',
          component: () =>
            import(
              '@/views/GestionPresupuestal/PresupuestoGasto/Parametrizacion/RubroGasto/pages/FormRubro.vue'
            ),
          meta: {
            showSidebar: false,
            permission: 'gestionpresupuestal.presupuestogasto.parametrizacion.rubrogasto.create',
            title: 'Crear rubro presupuestal del gasto',
            mainView: 'gestionpresupuestal.presupuestogasto.parametrizacion.rubrogasto',
          },
        },
      ],
    },

    {
      path: '/gestionpresupuestal/presupuestogasto/apropiacioninicial',
      name: 'gestionpresupuestal.presupuestogasto.apropiacioninicial',
      component: () =>
        import(
          '@/views/GestionPresupuestal/PresupuestoGasto/ApropiacionInicial/ApropiacionGastoMainView.vue'
        ),
      meta: {
        menuName: 'Apropiación inicial',
        title: 'Apropiación inicial presupuesto gasto',
        showSidebar: true,
        permission: 'gestionpresupuestal.presupuestogasto.apropiacioninicial',
        layout: 'MainLayout',
        parent: 'gestionpresupuestal.presupuestogasto',
      },
    },

    {
      path: '/gestionpresupuestal/presupuestogasto/disponibilidadpresupuestal',
      name: 'gestionpresupuestal.presupuestogasto.disponibilidadpresupuestal',
      component: () =>
        import(
          '@/views/GestionPresupuestal/PresupuestoGasto/Disponibilidad/DisponibilidadMainView.vue'
        ),
      meta: {
        menuName: 'Disponibilidad presupuestal',
        showSidebar: true,
        permission: 'gestionpresupuestal.presupuestogasto.disponibilidadpresupuestal',
        title: 'Disponibilidad presupuestal',
        layout: 'MainLayout',
        parent: 'gestionpresupuestal.presupuestogasto',
      },
      children: [
        {
          path: '/gestionpresupuestal/presupuestogasto/disponibilidadpresupuestal/solicitud',
          name: 'gestionpresupuestal.presupuestogasto.disponibilidadpresupuestal.create',
          component: () =>
            import(
              '@/views/GestionPresupuestal/PresupuestoGasto/Disponibilidad/pages/Solicitud/SolicitudDispMainView.vue'
            ),
          meta: {
            showSidebar: false,
            permission: 'gestionpresupuestal.presupuestogasto.disponibilidadpresupuestal.create',
            title: 'Solicitud disponibilidad presupuestal',
            mainView: 'gestionpresupuestal.presupuestogasto.disponibilidadpresupuestal',
            reload: false,
          },
        },
        {
          path: '/gestionpresupuestal/presupuestogasto/disponibilidadpresupuestal/anular/id/:id',
          name: 'gestionpresupuestal.presupuestogasto.disponibilidadpresupuestal.cancel',
          component: () =>
            import(
              '@/views/GestionPresupuestal/PresupuestoGasto/Disponibilidad/pages/Anulacion/AnularDisponibilidadMainView.vue'
            ),
          meta: {
            showSidebar: false,
            permission: 'gestionpresupuestal.presupuestogasto.disponibilidadpresupuestal.cancel',
            title: 'Anular disponibilidad presupuestal',
            mainView: 'gestionpresupuestal.presupuestogasto.disponibilidadpresupuestal',
            reload: false,
          },
        },
        {
          path: '/gestionpresupuestal/presupuestogasto/disponibilidadpresupuestal/view/id/:id',
          name: 'gestionpresupuestal.presupuestogasto.disponibilidadpresupuestal.view',
          component: () =>
            import(
              '@/views/GestionPresupuestal/PresupuestoGasto/Disponibilidad/pages/View/InfoDisponibilidad.vue'
            ),
          meta: {
            showSidebar: false,
            permission: 'gestionpresupuestal.presupuestogasto.disponibilidadpresupuestal',
            title: 'Disponibilidad presupuestal',
            mainView: 'gestionpresupuestal.presupuestogasto.disponibilidadpresupuestal',
            reload: false,
          },
        },
        {
          path: '/gestionpresupuestal/presupuestogasto/disponibilidadpresupuestal/reduccion/id/:id',
          name: 'gestionpresupuestal.presupuestogasto.disponibilidadpresupuestal.reduccion',
          component: () =>
            import(
              '@/views/GestionPresupuestal/PresupuestoGasto/Disponibilidad/pages/Reduccion/ReduccionDisponibilidad.vue'
            ),
          meta: {
            showSidebar: false,
            permission: 'gestionpresupuestal.presupuestogasto.disponibilidadpresupuestal.reducir',
            title: 'Reducción disponibilidad presupuestal',
            mainView: 'gestionpresupuestal.presupuestogasto.disponibilidadpresupuestal',
            reload: false,
          },
        },
        {
          path: '/gestionpresupuestal/presupuestogasto/disponibilidadpresupuestal/aprobacion/ordenadorgasto/id/:id',
          name: 'gestionpresupuestal.presupuestogasto.disponibilidadpresupuestal.solicitud.aprobacion.ordenadorgasto',
          component: () =>
            import(
              '../views/GestionPresupuestal/PresupuestoGasto/Disponibilidad/pages/AprobacionSolicitud/AprobacionSolicitud.vue'
            ),
          meta: {
            showSidebar: false,
            title: 'Aprobación ordenador gasto',
            mainView: 'gestionpresupuestal.presupuestogasto.disponibilidadpresupuestal',
            permiso:
              'gestionpresupuestal.presupuestogasto.disponibilidadpresupuestal.solicitud.aprobacion.ordenadorgasto',
          },
        },
        {
          path: '/gestionpresupuestal/presupuestogasto/disponibilidadpresupuestal/aprobacion/presupuesto/id/:id',
          name: 'gestionpresupuestal.presupuestogasto.disponibilidadpresupuestal.solicitud.aprobacion.presupuesto',
          component: () =>
            import(
              '../views/GestionPresupuestal/PresupuestoGasto/Disponibilidad/pages/AprobacionSolicitud/AprobacionSolicitud.vue'
            ),
          meta: {
            showSidebar: false,
            title: 'Aprobación ordenador gasto',
            mainView: 'gestionpresupuestal.presupuestogasto.disponibilidadpresupuestal',
            permiso:
              'gestionpresupuestal.presupuestogasto.disponibilidadpresupuestal.solicitud.aprobacion.presupuesto',
          },
        },
      ],
    },
    {
      path: '/gestionpresupuestal/presupuestogasto/registropresupuestal',
      name: 'gestionpresupuestal.presupuestogasto.registropresupuestal',
      component: () =>
        import('@/views/GestionPresupuestal/PresupuestoGasto/Registro/RegistroMainView.vue'),
      meta: {
        menuName: 'Registro presupuestal',
        showSidebar: true,
        permission: 'gestionpresupuestal.presupuestogasto.registropresupuestal',
        title: 'Registro presupuestal',
        layout: 'MainLayout',
        parent: 'gestionpresupuestal.presupuestogasto',
      },
      children: [
        {
          path: '/gestionpresupuestal/presupuestogasto/registropresupuestal/nuevo',
          name: 'gestionpresupuestal.presupuestogasto.registropresupuestal.create',
          component: () =>
            import('@/views/GestionPresupuestal/PresupuestoGasto/Registro/pages/NuevoRegistro.vue'),
          meta: {
            showSidebar: false,
            permission: 'gestionpresupuestal.presupuestogasto.registropresupuestal.create',
            title: 'Registro presupuestal',
            mainView: 'gestionpresupuestal.presupuestogasto.registropresupuestal',
            reload: true,
          },
        },
        {
          path: '/gestionpresupuestal/presupuestogasto/registropresupuestal/view/id/:id',
          name: 'gestionpresupuestal.presupuestogasto.registropresupuestal.view',
          component: () =>
            import('@/views/GestionPresupuestal/PresupuestoGasto/Registro/pages/InfoRegistro.vue'),
          meta: {
            showSidebar: false,
            permission: 'gestionpresupuestal.presupuestogasto.registropresupuestal',
            title: 'Registro presupuestal',
            mainView: 'gestionpresupuestal.presupuestogasto.registropresupuestal',
            reload: false,
          },
        },
        {
          path: '/gestionpresupuestal/presupuestogasto/registropresupuestal/decrease/id/:id',
          name: 'gestionpresupuestal.presupuestogasto.registropresupuestal.decrease',
          component: () =>
            import(
              '@/views/GestionPresupuestal/PresupuestoGasto/Registro/pages/DecreaseRegistro.vue'
            ),
          meta: {
            showSidebar: false,
            permission: 'gestionpresupuestal.presupuestogasto.registropresupuestal.update',
            title: 'Reducción registro presupuestal',
            mainView: 'gestionpresupuestal.presupuestogasto.registropresupuestal',
            reload: false,
          },
        },
        {
          path: '/gestionpresupuestal/presupuestogasto/registropresupuestal/dcancel/id/:id',
          name: 'gestionpresupuestal.presupuestogasto.registropresupuestal.delete',
          component: () =>
            import(
              '@/views/GestionPresupuestal/PresupuestoGasto/Registro/pages/AnularRegistro.vue'
            ),
          meta: {
            showSidebar: false,
            permission: 'gestionpresupuestal.presupuestogasto.registropresupuestal.delete',
            title: 'Anulación registro presupuestal',
            mainView: 'gestionpresupuestal.presupuestogasto.registropresupuestal',
            reload: false,
          },
        },
      ],
    },
    {
      path: '/gestionpresupuestal/presupuestoingreso',
      name: 'gestionpresupuestal.presupuestoingreso',
      component: () =>
        import('@/views/GestionPresupuestal/PresupuestoIngreso/PresupuestoIngresoMainView.vue'),
      meta: {
        menuName: 'Presupuesto ingreso',
        showSidebar: true,
        permission: 'gestionpresupuestal.presupuestoingreso',
        layout: 'MainLayout',
        parent: 'gestionpresupuestal',
      },
    },
    {
      path: '/gestionpresupuestal/presupuestoingreso/parametrizacion',
      name: 'gestionpresupuestal.presupuestoingreso.parametrizacion',
      component: () =>
        import(
          '@/views/GestionPresupuestal/PresupuestoIngreso/Parametrizacion/ParametrizacionMainView.vue'
        ),
      meta: {
        menuName: 'Parametrización',
        showSidebar: true,
        permission: 'gestionpresupuestal.presupuestoingreso.parametrizacion',
        layout: 'MainLayout',
        parent: 'gestionpresupuestal.presupuestoingreso',
      },
    },
    {
      path: '/gestionpresupuestal/presupuestoingreso/parametrizacion/catalogoccpet',
      name: 'gestionpresupuestal.presupuestoingreso.parametrizacion.catalogoccpet',
      component: () =>
        import(
          '@/views/GestionPresupuestal/PresupuestoIngreso/Parametrizacion/CatalogoCcpet/CatalogoCcpetMainView.vue'
        ),
      meta: {
        menuName: 'Catálogo CCPET',
        showSidebar: true,
        permission: 'gestionpresupuestal.presupuestoingreso.parametrizacion.catalogoccpet',
        title:
          'Catálogo Presupuestal para las Empresas Industriales y Comerciales del Estado (Ingreso)',
        layout: 'MainLayout',
        parent: 'gestionpresupuestal.presupuestoingreso.parametrizacion',
      },
    },
    {
      path: '/gestionpresupuestal/presupuestoingreso/parametrizacion/rubroingreso',
      name: 'gestionpresupuestal.presupuestoingreso.parametrizacion.rubroingreso',
      component: () =>
        import(
          '@/views/GestionPresupuestal/PresupuestoIngreso/Parametrizacion/RubroIngreso/RubroIngresoMainView.vue'
        ),
      meta: {
        menuName: 'Rubro ingreso',
        showSidebar: true,
        permission: 'gestionpresupuestal.presupuestoingreso.parametrizacion.rubroingreso',
        title: 'Rubro presupuestal del ingreso',
        layout: 'MainLayout',
        parent: 'gestionpresupuestal.presupuestoingreso.parametrizacion',
      },
      children: [
        {
          path: '/gestionpresupuestal/presupuestoingreso/parametrizacion/rubroingreso/nuevo',
          name: 'gestionpresupuestal.presupuestoingreso.parametrizacion.rubroingreso.create',
          component: () =>
            import(
              '@/views/GestionPresupuestal/PresupuestoIngreso/Parametrizacion/RubroIngreso/pages/RubroIngresoForm.vue'
            ),
          meta: {
            showSidebar: false,
            permission:
              'gestionpresupuestal.presupuestoingreso.parametrizacion.rubroingreso.create',
            title: 'Crear rubro presupuestal del ingreso',
            mainView: 'gestionpresupuestal.presupuestoingreso.parametrizacion.rubroingreso',
          },
        },
        {
          path: 'nuevo',
          name: 'gestionpresupuestal.presupuestoingreso.parametrizacion.rubroingreso.paramcontraloriadep',
          component: () => import('@/views/Dashboard/IndexDashboard.vue'),
          meta: {
            showSidebar: false,
            permission:
              'gestionpresupuestal.presupuestoingreso.parametrizacion.rubroingreso.paramcontraloriadep',
            title: 'Parametrización contraloría departamental',
            mainView: 'gestionpresupuestal.presupuestoingreso.parametrizacion.rubroingreso',
          },
        },
      ],
    },
    {
      path: '/gestionpresupuestal/presupuestoingreso/apropiacioninicial',
      name: 'gestionpresupuestal.presupuestoingreso.apropiacioninicial',
      component: () =>
        import(
          '@/views/GestionPresupuestal/PresupuestoIngreso/ApropiacionInicial/ApropiacionIngresoMainView.vue'
        ),
      meta: {
        menuName: 'Apropiación inicial',
        title: 'Apropiación inicial presupuesto ingreso',
        showSidebar: true,
        permission: 'gestionpresupuestal.presupuestoingreso.apropiacioninicial',
        layout: 'MainLayout',
        parent: 'gestionpresupuestal.presupuestoingreso',
      },
    },
    {
      path: '/gestionpresupuestal/modificacionpresupuestal',
      name: 'gestionpresupuestal.modificacionpresupuestal',
      component: () => import('@/views/GestionPresupuestal/Modificacion/ModificacionMainView.vue'),
      meta: {
        menuName: 'Modificación presupuestal',
        showSidebar: true,
        permission: 'gestionpresupuestal.modificacionpresupuestal',
        title: 'Modificación presupuestal',
        layout: 'MainLayout',
        parent: 'gestionpresupuestal',
      },
    },
    {
      path: '/gestionpresupuestal/modificacionpresupuestal/adicion',
      name: 'gestionpresupuestal.modificacionpresupuestal.adicion',
      component: () =>
        import('@/views/GestionPresupuestal/Modificacion/Adicion/AdicionMainView.vue'),
      meta: {
        menuName: 'Adición',
        showSidebar: true,
        permission: 'gestionpresupuestal.modificacionpresupuestal.adicion',
        title: 'Adición presupuestal',
        layout: 'MainLayout',
        parent: 'gestionpresupuestal.modificacionpresupuestal',
      },
      children: [
        {
          path: '/gestionpresupuestal/modificacionpresupuestal/adicion/nueva',
          name: 'gestionpresupuestal.modificacionpresupuestal.adicion.create',
          component: () =>
            import('@/views/GestionPresupuestal/Modificacion/Adicion/pages/NuevaAdicion.vue'),
          meta: {
            showSidebar: false,
            permission: 'gestionpresupuestal.modificacionpresupuestal.adicion.create',
            title: 'Nueva adición presupuestal',
            reload: true,
            mainView: 'gestionpresupuestal.modificacionpresupuestal.adicion',
          },
        },
        {
          path: '/gestionpresupuestal/modificacionpresupuestal/adicion/view/id/:id',
          name: 'gestionpresupuestal.modificacionpresupuestal.adicion.view',
          component: () =>
            import('@/views/GestionPresupuestal/Modificacion/Adicion/pages/InfoAdicion.vue'),
          meta: {
            showSidebar: false,
            permission: 'gestionpresupuestal.modificacionpresupuestal.adicion',
            title: 'Adición presupuestal',
            mainView: 'gestionpresupuestal.modificacionpresupuestal.adicion',
            reload: false,
          },
        },
      ],
    },
    {
      path: '/gestionpresupuestal/modificacionpresupuestal/traslado',
      name: 'gestionpresupuestal.modificacionpresupuestal.traslado',
      component: () =>
        import('@/views/GestionPresupuestal/Modificacion/Traslado/TrasladoMainView.vue'),
      meta: {
        menuName: 'Traslado',
        showSidebar: true,
        permission: 'gestionpresupuestal.modificacionpresupuestal.traslado',
        title: 'Traslado presupuestal',
        layout: 'MainLayout',
        parent: 'gestionpresupuestal.modificacionpresupuestal',
      },
      children: [
        {
          path: '/gestionpresupuestal/modificacionpresupuestal/traslado/nuevo',
          name: 'gestionpresupuestal.modificacionpresupuestal.traslado.create',
          component: () =>
            import('@/views/GestionPresupuestal/Modificacion/Traslado/pages/NuevoTraslado.vue'),
          meta: {
            showSidebar: false,
            permission: 'gestionpresupuestal.modificacionpresupuestal.traslado.create',
            title: 'Nuevo traslado presupuestal',
            reload: true,
            mainView: 'gestionpresupuestal.modificacionpresupuestal.traslado',
          },
        },
        {
          path: '/gestionpresupuestal/modificacionpresupuestal/traslado/view/id/:id',
          name: 'gestionpresupuestal.modificacionpresupuestal.traslado.view',
          component: () =>
            import('@/views/GestionPresupuestal/Modificacion/Traslado/pages/InfoTraslado.vue'),
          meta: {
            showSidebar: false,
            permission: 'gestionpresupuestal.modificacionpresupuestal.traslado',
            title: 'Traslado presupuestal',
            mainView: 'gestionpresupuestal.modificacionpresupuestal.traslado',
            reload: false,
          },
        },
      ],
    },
    {
      path: '/gestionpresupuestal/fuentefinanciacion',
      name: 'gestionpresupuestal.fuentefinanciacion',
      component: () =>
        import('@/views/GestionPresupuestal/FuenteFinanciacion/FuenteFinanciacionMainView.vue'),
      meta: {
        menuName: 'Fuente financiación',
        showSidebar: true,
        permission: 'gestionpresupuestal.fuentefinanciacion',
        title: 'Fuentes de financiación',
        layout: 'MainLayout',
        parent: 'gestionpresupuestal',
      },
      children: [
        {
          path: '/gestionpresupuestal/fuentefinanciacion/nueva',
          name: 'gestionpresupuestal.fuentefinanciacion.create',
          component: () =>
            import('@/views/GestionPresupuestal/FuenteFinanciacion/pages/FormFuente.vue'),
          meta: {
            showSidebar: false,
            permission: 'gestionpresupuestal.fuentefinanciacion.create',
            title: 'Crear fuente de financiación',
            reload: true,
            mainView: 'gestionpresupuestal.fuentefinanciacion',
          },
        },
      ],
    },
    // Gestion de tesoreria
    {
      path: '/gestiontesoreria',
      name: 'gestiontesoreria',
      component: () => import('@/views/GestionTesoreria/GestionTesoreriaMainView.vue'),
      meta: {
        iconClass: 'fa-solid fa-dollar-sign',
        menuName: 'Gestión de tesorería',
        showSidebar: true,
        permission: 'gestiontesoreria',
        layout: 'MainLayout',
      },
    },
    {
      path: '/gestiontesoreria/parametrizacion',
      name: 'gestiontesoreria.parametrizacion',
      component: () =>
        import('@/views/GestionTesoreria/Parametrizacion/TesoreriaParametrizacionMainView.vue'),
      meta: {
        menuName: 'Parametrización',
        showSidebar: true,
        permission: 'dashboard',
        title: 'Parametrización tesorería',
        layout: 'MainLayout',
        parent: 'gestiontesoreria',
      },
    },
    {
      path: '/gestiontesoreria/parametrizacion/impuestoretencion',
      name: 'gestiontesoreria.parametrizacion.impuestoretencion',
      component: () =>
        import(
          '@/views/GestionTesoreria/Parametrizacion/ImpuestoRetencion/ParamImpuestoMainView.vue'
        ),
      meta: {
        menuName: 'Impuestos y retenciones',
        showSidebar: true,
        permission: 'gestiontesoreria.parametrizacion.impuestoretencion',
        title: 'Parametrización impuestos y retenciones',
        layout: 'MainLayout',
        parent: 'gestiontesoreria.parametrizacion',
      },
      children: [
        {
          path: '/gestiontesoreria/parametrizacion/impuestoretencion/nuevo',
          name: 'gestiontesoreria.parametrizacion.impuestoretencion.create',
          component: () =>
            import(
              '@/views/GestionTesoreria/Parametrizacion/ImpuestoRetencion/pages/FormParametrizacionImpRetencion.vue'
            ),
          meta: {
            menuName: 'Tipo de ingreso',
            showSidebar: false,
            permission: 'gestiontesoreria.parametrizacion.impuestoretencion.create',
            title: 'Crear impuestos y retenciones',
            mainView: 'gestiontesoreria.parametrizacion.impuestoretencion',
          },
        },
        {
          path: '/gestiontesoreria/parametrizacion/impuestoretencion/copiarviganterior',
          name: 'gestiontesoreria.parametrizacion.impuestoretencion.clone',
          component: () =>
            import(
              '@/views/GestionTesoreria/Parametrizacion/ImpuestoRetencion/pages/Clonar/ClonarVigAnteriorMainView.vue'
            ),
          meta: {
            showSidebar: false,
            permission: 'gestiontesoreria.parametrizacion.impuestoretencion.clone',
            title: 'Copiar impuestos vigencia anterior',
            mainView: 'gestiontesoreria.parametrizacion.impuestoretencion',
          },
        },
      ],
    },
    {
      path: '/gestiontesoreria/ingreso',
      name: 'gestiontesoreria.ingreso',
      component: () => import('@/views/GestionTesoreria/Ingreso/TesoreriaIngresoMainView.vue'),
      meta: {
        menuName: 'Tesorería ingreso',
        showSidebar: true,
        permission: 'gestiontesoreria.ingreso',
        title: 'Tesorería ingreso',
        layout: 'MainLayout',
        parent: 'gestiontesoreria',
      },
    },
    {
      path: '/gestiontesoreria/parametrizacion',
      name: 'gestiontesoreria.ingreso.parametrizacion',
      component: () =>
        import(
          '@/views/GestionTesoreria/Parametrizacion/ImpuestoRetencion/ParamImpuestoMainView.vue'
        ),
      meta: {
        menuName: 'Parametrización',
        showSidebar: true,
        permission: 'dashboard',
        title: 'Parametrización tesorería ingreso',
        layout: 'MainLayout',
        parent: 'gestiontesoreria.ingreso',
      },
    },
    {
      path: '/gestiontesoreria/parametrizacion/tipoingreso',
      name: 'gestiontesoreria.ingreso.parametrizacion.tipoingreso',
      component: () =>
        import('@/views/GestionTesoreria/Parametrizacion/TipoIngreso/ParamTipoIngresoMainView.vue'),
      meta: {
        menuName: 'Tipo de ingreso',
        showSidebar: true,
        permission: 'gestiontesoreria.ingreso.parametrizacion.tipoingreso',
        title: 'Parametrización tipo de ingreso',
        layout: 'MainLayout',
        parent: 'gestiontesoreria.ingreso.parametrizacion',
      },
      children: [
        {
          path: '/gestiontesoreria/parametrizacion/tipoingreso/nuevo',
          name: 'gestiontesoreria.ingreso.parametrizacion.tipoingreso.create',
          component: () =>
            import(
              '@/views/GestionTesoreria/Parametrizacion/TipoIngreso/pages/FormTipoIngreso.vue'
            ),
          meta: {
            menuName: 'Tipo de ingreso',
            showSidebar: false,
            permission: 'gestiontesoreria.ingreso.parametrizacion.tipoingreso',
            title: 'Parametrización tipo de ingreso',
            mainView: 'gestiontesoreria.ingreso.parametrizacion.tipoingreso',
          },
        },
      ],
    },
    {
      path: '/gestiontesoreria/parametrizacion/tipodeposito',
      name: 'gestiontesoreria.ingreso.parametrizacion.tipodeposito',
      component: () =>
        import(
          '@/views/GestionTesoreria/Ingreso/Parametrizacion/TipoDeposito/TipoDepositoMainView.vue'
        ),
      meta: {
        menuName: 'Tipo depósito',
        showSidebar: true,
        permission: 'gestiontesoreria.ingreso.parametrizacion.tipodeposito',
        title: 'Parametrización tipo de depósito',
        layout: 'MainLayout',
        parent: 'gestiontesoreria.ingreso.parametrizacion',
      },
      children: [
        {
          path: '/gestiontesoreria/parametrizacion/tipodeposito/nuevo',
          name: 'gestiontesoreria.ingreso.parametrizacion.tipodeposito.create',
          component: () =>
            import(
              '@/views/GestionTesoreria/Ingreso/Parametrizacion/TipoDeposito/pages/FormTipoDeposito.vue'
            ),
          meta: {
            menuName: 'Tipo depósito',
            showSidebar: false,
            permission: 'gestiontesoreria.ingreso.parametrizacion.tipodeposito.create',
            title: 'Crear tipo de depósito',
            mainView: 'gestiontesoreria.ingreso.parametrizacion.tipodeposito',
            reload: true,
          },
        },
      ],
    },
    {
      path: '/gestiontesoreria/ingresocsf',
      name: 'gestiontesoreria.ingreso.ingresocsf',
      component: () => import('@/views/GestionTesoreria/Ingreso/IngresoCSF/IngresoCsfMainView.vue'),
      meta: {
        menuName: 'Ingreso CSF',
        showSidebar: true,
        permission: 'gestiontesoreria.ingreso.ingresocsf',
        title: 'Ingreso con situación de fondos',
        layout: 'MainLayout',
        parent: 'gestiontesoreria.ingreso',
      },
      children: [
        {
          path: '/gestiontesoreria/ingresocsf/view/id/:id',
          name: 'gestiontesoreria.ingreso.ingresocsf.view',
          component: () =>
            import('@/views/GestionTesoreria/Ingreso/IngresoCSF/pages/InfoIngresoCsf.vue'),
          meta: {
            showSidebar: false,
            permission: 'gestiontesoreria.ingreso.ingresocsf',
            title: 'Ingreso con situación de fondos',
            mainView: 'gestiontesoreria.ingreso.ingresocsf',
            reload: false,
          },
        },
               {
          path: '/gestiontesoreria/ingresocsf/cancel/id/:id',
          name: 'gestiontesoreria.ingreso.ingresocsf.cancel',
          component: () =>
            import('@/views/GestionTesoreria/Ingreso/IngresoCSF/pages/Anulacion/AnularIngresoCsf.vue'),
          meta: {
            showSidebar: false,
            permission: 'gestiontesoreria.ingreso.ingresocsf.cancel',
            title: 'Anular ingreso con situación de fondos',
            mainView: 'gestiontesoreria.ingreso.ingresocsf',
            reload: false,
          },
        },
        {
          path: '/gestiontesoreria/ingresocsf/nuevo',
          name: 'gestiontesoreria.ingreso.ingresocsf.create',
          component: () =>
            import('@/views/GestionTesoreria/Ingreso/IngresoCSF/pages/FormIngresoCsf.vue'),
          meta: {
            menuName: 'Ingreso CSF',
            showSidebar: false,
            permission: 'gestiontesoreria.ingreso.ingresocsf.create',
            title: 'Nuevo ingreso con situación de fondos',
            reload: true,
            mainView: 'gestiontesoreria.ingreso.ingresocsf',
          },
        },
      ],
    },
    {
      path: '/gestiontesoreria/ingresossf',
      name: 'gestiontesoreria.ingreso.ingresossf',
      component: () => import('@/views/GestionTesoreria/Ingreso/IngresoSSF/IngresoSsfMainView.vue'),
      meta: {
        menuName: 'Ingreso SSF',
        showSidebar: true,
        permission: 'gestiontesoreria.ingreso.ingresossf',
        title: 'Ingreso sin situación de fondos',
        layout: 'MainLayout',
        parent: 'gestiontesoreria.ingreso',
      },
      children: [
        {
          path: '/gestiontesoreria/ingresossf/nuevo',
          name: 'gestiontesoreria.ingreso.ingresossf.create',
          component: () =>
            import('@/views/GestionTesoreria/Ingreso/IngresoSSF/pages/FormIngresoSsf.vue'),
          meta: {
            menuName: 'Ingreso CSF',
            showSidebar: false,
            permission: 'gestiontesoreria.ingreso.ingresossf.create',
            title: 'Nuevo ingreso sin situación de fondos',
            reload: true,
            mainView: 'gestiontesoreria.ingreso.ingresossf',
          },
        },
      ],
    },
    {
      path: '/gestiontesoreria/notabancaria',
      name: 'gestiontesoreria.ingreso.notabancaria',
      component: () =>
        import('@/views/GestionTesoreria/Ingreso/NotaBancaria/NotaBancariaMainView.vue'),
      meta: {
        menuName: 'Nota bancaria',
        showSidebar: true,
        permission: 'gestiontesoreria.ingreso.notabancaria',
        title: 'Nota bancaria',
        layout: 'MainLayout',
        parent: 'gestiontesoreria.ingreso',
      },
    },
    {
      path: '/gestiontesoreria/notabancaria/traslado',
      name: 'gestiontesoreria.ingreso.notabancaria.traslado',
      component: () =>
        import('@/views/GestionTesoreria/Ingreso/NotaBancaria/Traslado/NotaTrasladoMainView.vue'),
      meta: {
        menuName: 'Traslado',
        showSidebar: true,
        permission: 'gestiontesoreria.ingreso.notabancaria.traslado',
        title: 'Nota bancaria traslado',
        layout: 'MainLayout',
        parent: 'gestiontesoreria.ingreso.notabancaria',
      },
      children: [
        {
          path: '/gestiontesoreria/notabancaria/traslado/nuevo',
          name: 'gestiontesoreria.ingreso.notabancaria.traslado.create',
          component: () =>
            import('@/views/GestionTesoreria/Ingreso/NotaBancaria/Traslado/pages/FormTraslado.vue'),
          meta: {
            showSidebar: false,
            permission: 'gestiontesoreria.ingreso.notabancaria.traslado.create',
            title: 'Nota bancaria traslado',
            mainView: 'gestiontesoreria.ingreso.notabancaria.traslado',
          },
        },
        {
          path: '/gestiontesoreria/notabancaria/traslado/view/id/:id',
          name: 'gestiontesoreria.ingreso.notabancaria.traslado.view',
          component: () =>
            import('@/views/GestionTesoreria/Ingreso/NotaBancaria/Traslado/pages/InfoTraslado.vue'),
          meta: {
            showSidebar: false,
            permission: 'gestiontesoreria.ingreso.notabancaria.traslado',
            title: 'Nota bancaria traslado',
            mainView: 'gestiontesoreria.ingreso.notabancaria.traslado',
            reload: false,
          },
        },
      ],
    },
    {
      path: '/gestiontesoreria/deposito',
      name: 'gestiontesoreria.ingreso.deposito',
      component: () => import('@/views/GestionTesoreria/Ingreso/Deposito/DepositoMainView.vue'),
      meta: {
        menuName: 'Depósito',
        showSidebar: true,
        permission: 'gestiontesoreria.ingreso.deposito',
        title: 'Depósito',
        layout: 'MainLayout',
        parent: 'gestiontesoreria.ingreso',
      },
      children: [
        {
          path: '/gestiontesoreria/deposito/nuevo',
          name: 'gestiontesoreria.ingreso.deposito.create',
          component: () =>
            import('@/views/GestionTesoreria/Ingreso/Deposito/pages/FormularioDeposito.vue'),
          meta: {
            menuName: 'Nuevo depósito',
            showSidebar: false,
            permission: 'gestiontesoreria.ingreso.deposito.create',
            title: 'Nuevo depósito',
            mainView: 'gestiontesoreria.ingreso.deposito',
            reload: true,
          },
        },
        {
          path: '/gestiontesoreria/deposito/view/id/:id',
          name: 'gestiontesoreria.ingreso.deposito.view',
          component: () =>
            import('@/views/GestionTesoreria/Ingreso/Deposito/pages/InfoDeposito.vue'),
          meta: {
            showSidebar: false,
            permission: 'gestiontesoreria.ingreso.deposito',
            title: 'Depósito',
            mainView: 'gestiontesoreria.ingreso.deposito',
            reload: false,
          },
        },
      ],
    },
    {
      path: '/gestiontesoreria/gasto',
      name: 'gestiontesoreria.gasto',
      component: () => import('@/views/GestionTesoreria/Gasto/TesoreriaGastoMainView.vue'),
      meta: {
        menuName: 'Tesorería gasto',
        showSidebar: true,
        permission: 'dashboard',
        title: 'Tesorería gasto',
        layout: 'MainLayout',
        parent: 'gestiontesoreria',
      },
    },
    {
      path: '/gestiontesoreria/gasto/cuentasporpagar',
      name: 'gestiontesoreria.gasto.cuentaporpagar',
      component: () =>
        import('@/views/GestionTesoreria/Gasto/CuentasPorPagar/CuentasPorPagarMainView.vue'),
      meta: {
        menuName: 'Cuentas por pagar',
        showSidebar: true,
        permission: 'gestiontesoreria.gasto.cuentaporpagar',
        title: 'Cuentas por pagar',
        layout: 'MainLayout',
        parent: 'gestiontesoreria.gasto',
      },
      children: [
        {
          path: '/gestiontesoreria/gasto/cuentasporpagar/view/id/:id',
          name: 'gestiontesoreria.gasto.cuentaporpagar.view',
          component: () =>
            import('@/views/GestionTesoreria/Gasto/CuentasPorPagar/pages/InfoCuentaPorPagar.vue'),
          meta: {
            showSidebar: false,
            permission: 'gestiontesoreria.gasto.cuentaporpagar',
            title: 'Cuenta por pagar',
            mainView: 'gestiontesoreria.gasto.cuentaporpagar',
            reload: false,
          },
        },
        {
          path: '/gestiontesoreria/gasto/cuentasporpagar/anular/id/:id',
          name: 'gestiontesoreria.gasto.cuentaporpagar.cancel',
          component: () =>
            import('@/views/GestionTesoreria/Gasto/CuentasPorPagar/pages/AnularCuentaPorPagar.vue'),
          meta: {
            showSidebar: false,
            permission: 'gestiontesoreria.gasto.cuentaporpagar',
            title: 'Anular cuenta por pagar',
            mainView: 'gestiontesoreria.gasto.cuentaporpagar',
            reload: false,
          },
        },
        {
          path: 'nuevo/contrato',
          name: 'gestiontesoreria.gasto.cuentaporpagar.contrato.create',
          component: () =>
            import(
              '@/views/GestionTesoreria/Gasto/CuentasPorPagar/pages/CxpContrato/CxpContratoNew.vue'
            ),
          meta: {
            showSidebar: false,
            permission: 'gestiontesoreria.gasto.cuentaporpagar.contrato.create',
            title: 'Nueva cuenta por pagar',
            mainView: 'gestiontesoreria.gasto.cuentaporpagar',
          },
        },
        {
          path: 'nuevo/nomina',
          name: 'gestiontesoreria.gasto.cuentaporpagar.nomina.create',
          component: () =>
            import(
              '@/views/GestionTesoreria/Gasto/CuentasPorPagar/pages/CxpNomina/CxpNominaNew.vue'
            ),
          meta: {
            showSidebar: false,
            permission: 'gestiontesoreria.gasto.cuentaporpagar.nomina.create',
            title: 'Nueva cuenta por pagar',
            mainView: 'gestiontesoreria.gasto.cuentaporpagar',
          },
        },
        {
          path: 'nuevo/vigenciaanterior',
          name: 'gestiontesoreria.gasto.cuentaporpagar.vigenciaanterior.create',
          component: () =>
            import(
              '@/views/GestionTesoreria/Gasto/CuentasPorPagar/pages/VigenciaAnterior/CxpVigAnteriorNew.vue'
            ),
          meta: {
            showSidebar: false,
            permission: 'gestiontesoreria.gasto.cuentaporpagar.vigenciaanterior.create',
            title: 'Cuenta por pagar vigencia anterior',
            mainView: 'gestiontesoreria.gasto.cuentaporpagar',
          },
        },
      ],
    },
    {
      path: '/gestiontesoreria/gasto/egreso',
      name: 'gestiontesoreria.gasto.comprobanteegreso',
      component: () =>
        import('@/views/GestionTesoreria/Gasto/ComprobanteEgreso/ComprobanteEgresoMainView.vue'),
      meta: {
        menuName: 'Comprobante de egreso',
        showSidebar: true,
        permission: 'gestiontesoreria.gasto.comprobanteegreso',
        title: 'Comprobante de egreso',
        layout: 'MainLayout',
        parent: 'gestiontesoreria.gasto',
      },
      children: [
        {
          path: '/gestiontesoreria/gasto/egreso/view/id/:id',
          name: 'gestiontesoreria.gasto.comprobanteegreso.view',
          component: () =>
            import(
              '@/views/GestionTesoreria/Gasto/ComprobanteEgreso/pages/InfoComprobanteEgreso.vue'
            ),
          meta: {
            showSidebar: false,
            permission: 'gestiontesoreria.gasto.comprobanteegreso',
            title: 'Comprobante de egreso',
            mainView: 'gestiontesoreria.gasto.comprobanteegreso',
            reload: false,
          },
        },
        {
          path: '/gestiontesoreria/gasto/egreso/anular/id/:id',
          name: 'gestiontesoreria.gasto.comprobanteegreso.cancel',
          component: () =>
            import('@/views/GestionTesoreria/Gasto/ComprobanteEgreso/pages/AnularEgreso.vue'),
          meta: {
            showSidebar: false,
            permission: 'gestiontesoreria.gasto.comprobanteegreso',
            title: 'Anular comprobante egreso',
            mainView: 'gestiontesoreria.gasto.comprobanteegreso',
            reload: false,
          },
        },
        {
          path: '/gestiontesoreria/gasto/egreso/cuentaporpagar/nuevo',
          name: 'gestiontesoreria.gasto.comprobanteegreso.create.cuentaporpagar',
          component: () =>
            import(
              '@/views/GestionTesoreria/Gasto/ComprobanteEgreso/pages/CuentaPorPagar/EgresoCxpNew.vue'
            ),
          meta: {
            showSidebar: false,
            permission: 'gestiontesoreria.gasto.comprobanteegreso.create.cuentaporpagar',
            title: 'Comprobante de egreso',
            mainView: 'gestiontesoreria.gasto.comprobanteegreso',
          },
        },
        {
          path: '/gestiontesoreria/gasto/egreso/tesoral/nuevo',
          name: 'gestiontesoreria.gasto.comprobanteegreso.create.tesoral',
          component: () =>
            import(
              '@/views/GestionTesoreria/Gasto/ComprobanteEgreso/pages/Tesoral/EgresoTesoralNew.vue'
            ),
          meta: {
            showSidebar: false,
            permission: 'gestiontesoreria.gasto.comprobanteegreso.create.cuentaporpagar',
            title: 'Comprobante de egreso',
            mainView: 'gestiontesoreria.gasto.comprobanteegreso',
          },
        },
        {
          path: '/gestiontesoreria/gasto/egreso/nomina/nuevo',
          name: 'gestiontesoreria.gasto.comprobanteegreso.create.nomina',
          component: () =>
            import(
              '@/views/GestionTesoreria/Gasto/ComprobanteEgreso/pages/Nomina/EgresoNominaNew.vue'
            ),
          meta: {
            showSidebar: false,
            permission: 'gestiontesoreria.gasto.comprobanteegreso.create.nomina',
            title: 'Comprobante de egreso vigencia anterior',
            mainView: 'gestiontesoreria.gasto.comprobanteegreso',
          },
        },
        {
          path: '/gestiontesoreria/gasto/comprobanteegreso/vigenciaanterior/nuevo',
          name: 'gestiontesoreria.gasto.comprobanteegreso.vigenciaanterior.create',
          component: () =>
            import(
              '@/views/GestionTesoreria/Gasto/ComprobanteEgreso/VigenciaAnterior/EgresoVigAnteriorMainView.vue'
            ),
          meta: {
            showSidebar: false,
            permission: 'gestiontesoreria.gasto.comprobanteegreso.create.nomina',
            title: 'Comprobante de egreso nomina',
            mainView: 'gestiontesoreria.gasto.comprobanteegreso',
          },
        },
        {
          path: '/gestiontesoreria/gasto/egreso/deduccionnomina/nuevo',
          name: 'gestiontesoreria.gasto.comprobanteegreso.create.deduccionnomina',
          component: () =>
            import(
              '@/views/GestionTesoreria/Gasto/ComprobanteEgreso/pages/DeduccionNomina/EgresoDeduccionNominaNew.vue'
            ),
          meta: {
            showSidebar: false,
            permission: 'gestiontesoreria.gasto.comprobanteegreso.create.cuentaporpagar',
            title: 'Comprobante de egreso deducción nomina',
            mainView: 'gestiontesoreria.gasto.comprobanteegreso',
          },
        },
      ],
    },
    {
      path: '/gestiontesoreria/bancos',
      name: 'gestiontesoreria.bancos',
      component: () => import('@/views/GestionTesoreria/Bancos/BancoMainView.vue'),
      meta: {
        menuName: 'Bancos',
        showSidebar: true,
        permission: 'gestiontesoreria.bancos',
        title: 'Bancos',
        layout: 'MainLayout',
        parent: 'gestiontesoreria',
      },
    },
    {
      path: '/gestiontesoreria/cuentasbancarias',
      name: 'gestiontesoreria.bancos.cuentasbancarias',
      component: () =>
        import('@/views/GestionTesoreria/Bancos/CuentasBancarias/MainViewCuentasBancarias.vue'),
      meta: {
        menuName: 'Cuentas bancarias',
        showSidebar: true,
        permission: 'gestiontesoreria.bancos.cuentasbancarias',
        title: 'Cuentas bancarias',
        layout: 'MainLayout',
        parent: 'gestiontesoreria.bancos',
      },
      children: [
        {
          path: '/gestiontesoreria/cuentasbancarias/nueva',
          name: 'gestiontesoreria.bancos.cuentasbancarias.create',
          component: () =>
            import(
              '@/views/GestionTesoreria/Bancos/CuentasBancarias/pages/NuevaCuentaBancaria.vue'
            ),
          meta: {
            showSidebar: false,
            permission: 'gestiontesoreria.bancos.cuentasbancarias.create',
            title: 'Crear cuenta bancaria',
            mainView: 'gestiontesoreria.bancos.cuentasbancarias',
            reload: true,
          },
        },
      ],
    },
    //Contabilidad
    {
      path: '/contabilidad',
      name: 'contabilidad',
      component: () => import('@/views/Contabilidad/ContabilidadMainView.vue'),
      meta: {
        iconClass: 'fa-solid fa-scale-balanced',
        menuName: 'Contabilidad',
        showSidebar: true,
        permission: 'contabilidad',
        layout: 'MainLayout',
      },
    },

    {
      path: '/contabilidad/catalogocuentas',
      name: 'contabilidad.catalogocuentas',
      component: () => import('@/views/Contabilidad/CatalogoCuentas/CatalogoCuentasMainView.vue'),
      meta: {
        menuName: 'Catálogo cuentas',
        showSidebar: true,
        permission: 'contabilidad.catalogocuentas',
        title: 'Catálogo de cuentas contables',
        layout: 'MainLayout',
        parent: 'contabilidad',
      },
      children: [
        {
          path: '/contabilidad/catalogocuentas/:id/nueva',
          name: 'contabilidad.catalogocuentas.create',
          component: () => import('../views/Contabilidad/CatalogoCuentas/pages/NuevaCuenta.vue'),
          meta: {
            showSidebar: false,
            title: 'Creación cuenta contable',
            permiso: 'contabilidad.catalogocuentas.create',
            mainView: 'contabilidad.catalogocuentas',
          },
        },
        {
          path: '/contabilidad/catalogocuentas/edit/id/:id',
          name: 'contabilidad.catalogocuentas.update',
          component: () =>
            import('../views/Contabilidad/CatalogoCuentas/pages/EditarCuentaContable.vue'),
          meta: {
            showSidebar: false,
            title: 'Editar cuenta contable',
            permiso: 'contabilidad.catalogocuentas.update',
            mainView: 'contabilidad.catalogocuentas',
          },
        },
      ],
    },

    {
      path: '/contabilidad/comprobantecontable',
      name: 'contabilidad.comprobantecontable',
      component: () =>
        import('@/views/Contabilidad/ComprobanteContable/ComprobanteContableMainView.vue'),
      meta: {
        menuName: 'Comprobante contable',
        showSidebar: true,
        permission: 'contabilidad.comprobantecontable',
        title: 'Comprobante contable',
        layout: 'MainLayout',
        parent: 'contabilidad',
      },
      children: [
        {
          path: '/contabilidad/comprobantecontable/nuevo',
          name: 'contabilidad.comprobantecontable.create',
          component: () =>
            import('@/views/Contabilidad/ComprobanteContable/FormularioComprobanteContable.vue'),
          meta: {
            showSidebar: false,
            title: 'Nuevo comprobante contable',
            permission: 'contabilidad.comprobantecontable.create',
            mainView: 'contabilidad.comprobantecontable',
            reload: true,
          },
        },
        {
          path: '/contabilidad/comprobantecontable/info/:id',
          name: 'contabilidad.comprobantecontable.info',
          component: () =>
            import('../views/Contabilidad/ComprobanteContable/pages/InfoComprobanteContable.vue'),
          meta: {
            title: 'Comprobante contable',
            showSidebar: false,
            permiso: 'contabilidad.comprobantecontable',
            mainView: 'contabilidad.comprobantecontable',
            reload: false,
          },
        },
        {
          path: '/contabilidad/comprobantecontable/anular/:id',
          name: 'contabilidad.comprobantecontable.delete',
          component: () =>
            import('../views/Contabilidad/ComprobanteContable/pages/AnularComprobanteContable.vue'),
          meta: {
            title: 'Anulación comprobante contable',
            showSidebar: false,
            permiso: 'contabilidad.comprobantecontable.delete',
            mainView: 'contabilidad.comprobantecontable',
            reload: false,
          },
        },
      ],
    },
    {
      path: '/contabilidad/movimientocobntable',
      name: 'contabilidad.movimientocontable',
      component: () => import('@/views/Contabilidad/MovimientoContable/MovContableMainView.vue'),
      meta: {
        menuName: 'Movimientos contables',
        showSidebar: true,
        permission: 'contabilidad.movimientocontable',
        title: 'Movimientos contables',
        layout: 'MainLayout',
        parent: 'contabilidad',
      },
    },
    {
      path: '/contabilidad/periodocontable',
      name: 'contabilidad.periodocontable',
      component: () => import('@/views/Contabilidad/PeriodoContable/PeriodoContableMainView.vue'),
      meta: {
        menuName: 'Período contable',
        showSidebar: true,
        permission: 'contabilidad.comprobantecontable',
        title: 'Período contable',
        layout: 'MainLayout',
        parent: 'contabilidad',
      },
    },

    // Reportes
    {
      path: '/reporte',
      name: 'reporte',
      component: () => import('@/views/Reporte/ReporteMainView.vue'),
      meta: {
        iconClass: 'fas fa-chart-line',
        menuName: 'Reportes',
        showSidebar: true,
        permission: 'reporte',
        title: 'Reportes',
        layout: 'MainLayout',
      },
      children: [
        {
          path: '/reporte/contabilidad/balanceprueba',
          name: 'reporte.contabilidad.balanceprueba',
          component: () =>
            import('@/views/Reporte/Contable/BalancePrueba/BalancePruebaMainView.vue'),
          meta: {
            showSidebar: false,
            permission: 'reporte.contabilidad.balanceprueba',
            title: 'Balance de prueba',
            mainView: 'reporte',
          },
        },
        {
          path: '/reporte/contabilidad/balancepruebatercero',
          name: 'reporte.contabilidad.balancepruebatercero',
          component: () =>
            import('@/views/Reporte/Contable/BalancePruebaTercero/BalancePruebaTerceroMainView.vue'),
          meta: {
            showSidebar: false,
            permission: 'reporte.contabilidad.balancepruebatercero',
            title: 'Balance de prueba',
            mainView: 'reporte',
          },
        },

        {
          path: '/reporte/contabilidad/movimientocuentacontable',
          name: 'reporte.contabilidad.movimientocuentacontable',
          component: () =>
            import('@/views/Reporte/Contable/MovimientoCuentaContable/MovCuentaContablaMainView.vue'),
          meta: {
            showSidebar: false,
            permission: 'reporte.contabilidad.movimientocuentacontable',
            title: 'Movimientos por cuenta contable',
            mainView: 'reporte',
          },
        },




        {
          path: '/reporte/contabilidad/retencionespracticadas',
          name: 'reporte.contabilidad.retencionespracticadas',
          component: () =>
            import('@/views/Reporte/Contable/RetencionPracticada/retencionPracticadaMainView.vue'),
          meta: {
            showSidebar: false,
            permission: 'reporte.contabilidad.retencionespracticadas',
            title: 'Retenciones practicadas',
            mainView: 'reporte',
          },
        },
        {
          path: '/reporte/contabilidad/auxiliartercero',
          name: 'reporte.contabilidad.auxiliartercero',
          component: () =>
            import('@/views/Reporte/Contable/AuxiliarTercero/AuxiliarTerceroMainView.vue'),
          meta: {
            showSidebar: false,
            permission: 'reporte.contabilidad.auxiliartercero',
            title: 'Auxiliar por tercero',
            mainView: 'reporte',
          },
        },
        {
          path: '/reporte/contabilidad/auxiliartercero2',
          name: 'reporte.contabilidad.auxiliartercero2',
          component: () =>
            import('@/views/Reporte/Contable/AuxiliarTercero/AuxiliarTercero2MainView.vue'),
          meta: {
            showSidebar: false,
            permission: 'reporte.contabilidad.auxiliartercero',
            title: 'Auxiliar por tercero',
            mainView: 'reporte',
          },
        },
        {
          path: '/reporte/contabilidad/auxiliarcuenta',
          name: 'reporte.contabilidad.auxiliarcuenta',
          component: () =>
            import('@/views/Reporte/Contable/AuxiliarCuenta/AuxiliarCuentaMainView.vue'),
          meta: {
            showSidebar: false,
            permission: 'reporte.contabilidad.auxiliarcuenta',
            title: 'Auxiliar por cuenta contable',
            mainView: 'reporte',
          },
        },
        {
          path: '/reporte/contabilidad/cgn2015001',
          name: 'reporte.contabilidad.cgn2015001',
          component: () => import('@/views/Reporte/Contable/CGN2015001/CGN2015001MainView.vue'),
          meta: {
            showSidebar: false,
            permission: 'reporte.contabilidad.cgn2015001',
            title: 'Formulario CGN2015_001 Saldos y movimientos convergencia',
            mainView: 'reporte',
          },
        },
        {
          path: '/reporte/contabilidad/cgn2015002',
          name: 'reporte.contabilidad.cgn2015002',
          component: () => import('@/views/Reporte/Contable/CGN2015002/CGN2015002MainView.vue'),
          meta: {
            showSidebar: false,
            permission: 'reporte.contabilidad.Reportecgn2015002',
            title: 'Formulario CGN2015_002 Operaciones recíprocas convergencia',
            mainView: 'reporte',
          },
        },
        {
          path: '/reporte/contable/librobanco',
          name: 'reporte.contabilidad.librobanco',
          component: () => import('@/views/Reporte/Contable/LibroBanco/LibroBancoMainView.vue'),
          meta: {
            showSidebar: false,
            permission: 'reporte.contabilidad.librobanco',
            title: 'Libro banco',
            mainView: 'reporte',
          },
        },
        {
          path: '/reporte/contable/informacionexogena',
          name: 'reporte.contabilidad.informacionexogena',
          component: () => import('@/views/Reporte/Contable/InformacionExogena/InformacionExogenaMainView.vue'),
          meta: {
            showSidebar: false,
            permission: 'reporte.contabilidad.informacionexogena',
            title: 'Reporte información exógena',
            mainView: 'reporte',
          },
        },
        {
          path: '/reporte/presupuesto/ingreso/rubroestructurageneral',
          name: 'reporte.presupuesto.ingreso.rubroestructurageneral',
          component: () =>
            import(
              '@/views/Reporte/Presupuesto/Ingreso/RubroEstructuraGeneral/RubroEstrucGeneralMainView.vue'
            ),
          meta: {
            showSidebar: false,
            permission: 'reporte.presupuesto.ingreso.rubroestructurageneral',
            title: 'Presupuesto ingreso rubro estructura general',
            mainView: 'reporte',
          },
        },

        {
          path: '/reporte/presupuesto/gasto/rubroestructurageneral',
          name: 'reporte.presupuesto.gasto.rubroestructurageneral',
          component: () =>
            import(
              '@/views/Reporte/Presupuesto/Gasto/RubroEstructuraGeneral/RubroEstrucGeneralMainView.vue'
            ),
          meta: {
            showSidebar: false,
            permission: 'reporte.presupuesto.gasto.rubroestructurageneral',
            title: 'Presupuesto gasto rubro estructura general',
            mainView: 'reporte',
          },
        },
        {
          path: '/reporte/presupuesto/cuipo/ejecuciongasto',
          name: 'reporte.presupuesto.cuipo.ejecuciongasto',
          component: () =>
            import('@/views/Reporte/Presupuesto/Cuipo/EjecucionGasto/IndexEjecucionGasto.vue'),
          meta: {
            showSidebar: false,
            permission: 'reporte.presupuesto.cuipo.ejecuciongasto',
            title: 'Reporte CUIPO ejecución de gastos',
            mainView: 'reporte',
          },
        },
      ],
    },
  ],
})

router.onError((error) => {
  console.error('Router error:', error)
})

router.beforeEach(async (to) => {
  const publicPages = ['/login', '/register']
  const authRequired = !publicPages.includes(to.path)
  const auth = useAuthStore()

  if (authRequired) {
    if (auth.user) {
      await auth.checkAuth()
    }

    if (!auth.user) {
      auth.returnUrl = to.fullPath
      return '/login'
    } else {
      if (
        !to.meta.permission ||
        to.meta.permission === undefined ||
        !auth.permisos.includes(to.meta.permission)
      ) {
        console.log('No tiene permiso para accesar el contenido')
        console.log(to.meta.permission)
        // alert(to.meta.permission)
        // return '/'
      }
    }
  }
})

//global para actualizar el título
router.afterEach((to) => {
  const defaultTitle = 'SEAP'
  document.title = to.meta.menuName ? `${to.meta.menuName} - SEAP` : defaultTitle
})

export default router
